import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login from './pages/Login';
import Register from './pages/Register';
import Profile from './pages/Profile';
import MilesLogging from './pages/MilesLogging';
import AdminDashboard from './pages/AdminDashboard';
import TeamView from './pages/TeamView';
import Leaderboards from './pages/Leaderboards';
import Donate from './pages/Donate';
import InviteFriends from './pages/InviteFriends';
import Dashboard from './pages/Dashboard';

// Protected Route Component
const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { currentUser, loading } = useAuth();

  if (loading) {
    // Optionally show a loading spinner while checking auth status
    return <div>Loading...</div>;
  }

  return currentUser ? <>{children}</> : <Navigate to="/login" />;
};

// Admin Route Component
const AdminRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { currentUser, userDetails, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  // Check if user is logged in and is an admin
  return currentUser && userDetails?.isAdmin ? (
    <>{children}</>
  ) : (
    <Navigate to="/" /> // Redirect non-admins to the home page or login
  );
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/donate" element={<Donate />} />
          
          {/* Protected Routes */}
          <Route 
            path="/" 
            element={<ProtectedRoute><Dashboard /></ProtectedRoute>} 
          />
          <Route 
            path="/dashboard" 
            element={<ProtectedRoute><Dashboard /></ProtectedRoute>}
          />
          <Route 
            path="/profile" 
            element={<ProtectedRoute><Profile /></ProtectedRoute>} 
          />
          <Route 
            path="/miles" 
            element={<ProtectedRoute><MilesLogging /></ProtectedRoute>} 
          />
          <Route 
            path="/teams/:teamId" 
            element={<ProtectedRoute><TeamView /></ProtectedRoute>} 
          />
          <Route 
            path="/leaderboards" 
            element={<ProtectedRoute><Leaderboards /></ProtectedRoute>} 
          />
          <Route 
            path="/invite" 
            element={<ProtectedRoute><InviteFriends /></ProtectedRoute>} 
          />

          {/* Admin Routes */}
          <Route 
            path="/admin" 
            element={<AdminRoute><AdminDashboard /></AdminRoute>} 
          />
          
          {/* Redirect any unknown paths to home */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
